import { useCallback, useEffect, useRef, useState } from 'react'
import APIService from 'services/APIService'
import { useComplianceChanged } from 'utils/complianceEvents'

const api = APIService()
const cache = new Map()

export const complianceSummaryEndpoint = ({ bpId, portfolioId, estateId } = {}) => {
  if (bpId) return `/building-passport/${bpId}/compliance/summary`
  if (portfolioId) return `/portfolios/${portfolioId}/compliance/summary`
  if (estateId) return `/estates/${estateId}/compliance/summary`
  return null
}

export const clearComplianceSummaryCache = () => cache.clear()

export const useComplianceSummary = (scope, enabled = true) => {
  const endpoint = enabled ? complianceSummaryEndpoint(scope) : null
  const [summary, setSummary] = useState(() => (endpoint ? cache.get(endpoint) : null) || null)
  const seqRef = useRef(0)

  const load = useCallback(() => {
    if (!endpoint) return
    const seq = ++seqRef.current
    api.get(endpoint)
      .then(res => {
        const data = res?.data?.data || null
        if (data) cache.set(endpoint, data)
        if (seq === seqRef.current) setSummary(data)
      })
      .catch(() => {})
  }, [endpoint])

  useEffect(() => {
    setSummary(endpoint ? cache.get(endpoint) || null : null)
    load()
  }, [endpoint, load])

  useComplianceChanged(load)

  return summary
}
